module.exports = __webpack_public_path__ + "img/uncommon.2c8b8e55.png";